import { WIDGET_MESSAGE } from './constants';
import type { WidgetMessageType } from './types';

export const isValidWidgetMessageType = (type: string): type is WidgetMessageType =>
  (Object.values(WIDGET_MESSAGE) as string[]).includes(type);
